import {
  IconButton,
  Menu,
  MenuContent,
  MenuItem,
  MenuTrigger,
} from '@utilitywarehouse/hearth-react';
import {
  InfoSmallIcon,
  MoreSmallIcon,
  PhoneSmallIcon,
} from '@utilitywarehouse/hearth-react-icons';
import { useRef, useState } from 'react';

import { useUserInformation } from '@hooks/useUserInformation';

interface OptionsMenuProps {
  onEnd: () => void;
  onOpenInfo: () => void;
}

const OptionsMenu = ({ onEnd, onOpenInfo }: OptionsMenuProps) => {
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const handleToggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleClose = () => {
    setMenuOpen(false);
  };

  const handleEndAppointment = () => {
    onEnd();
    handleClose();
  };

  const handleOpenDetails = () => {
    onOpenInfo();
    handleClose();
  };

  const userInformation = useUserInformation();

  return (
    <Menu modal={false}>
      <MenuTrigger>
        <IconButton
          variant="outline"
          size="sm"
          label="Session options"
          colorScheme="functional"
          inverted
          onClick={handleToggleMenu}
          ref={anchorRef}
        >
          <MoreSmallIcon />
        </IconButton>
      </MenuTrigger>
      <MenuContent placement="bottomRight">
        {userInformation && (
          <MenuItem onClick={handleOpenDetails}>
            <span className="session_controls-header__optionsItemContent">
              <InfoSmallIcon />
              Appointment details
            </span>
          </MenuItem>
        )}
        <MenuItem onClick={handleEndAppointment}>
          <span className="session_controls-header__optionsItemContent">
            <PhoneSmallIcon className="session_controls-header__optionsIconEnd" />
            End appointment
          </span>
        </MenuItem>
      </MenuContent>
    </Menu>
  );
};

export { OptionsMenu };
